var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.header},[(_vm.showBackBtn)?_c('BackBtn'):_vm._e(),_c('p',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }